export default __webpack_public_path__ + "static/media/wordmark-primary.db2c711c.png";